import classnames from 'classnames';
import React from 'react';

import styles from './SearchResultPlaceholder.module.scss';

/**
 * The SearchResultPlaceholder component is a placeholder for unloaded search results.
 * @param {object} props - The component props
 * @param {string} props.className - Additional class name
 * @returns {React.Component} The search result placeholder component
 */
const SearchResultPlaceholder = ({ className, ...props }) => {
    return (
        <article className={classnames(styles['search-result-placeholder'], className)} {...props}>
            {Array.from({ length: 7 }).map((_, index) => (
                <div key={index} className={styles['search-result-placeholder__item']} />
            ))}
        </article>
    );
};

export default SearchResultPlaceholder;
